import { supabase } from '@/integrations/supabase/client';
import { mapVaultPage, upsertVaultPage } from '@/lib/librarian/api';
import type { KnowledgeBaseVault } from '@/lib/librarian/types';

export async function updateLogPage(vault: KnowledgeBaseVault, entry: string) {
  const { data, error } = await supabase
    .from('knowledge_base_vault_pages')
    .select('*')
    .eq('vault_id', vault.id)
    .eq('path', 'log.md')
    .maybeSingle();

  if (error) throw error;

  const existing = data ? mapVaultPage(data) : null;
  const line = `- ${new Date().toISOString()} — ${entry}`;
  const content = [existing?.content_markdown || '# Vault Activity Log', '', line].filter(Boolean).join('\n');

  return upsertVaultPage({
    vaultId: vault.id,
    path: 'log.md',
    title: 'Vault Log',
    pageType: 'log',
    contentMarkdown: content,
    summary: 'Chronological librarian activity log.',
    metadata: { generatedBy: 'librarian' },
  });
}
